import React,
{
  useEffect,
  useState,
} from "react";

import {
  useParams,
} from "react-router-dom";

const SingleHouse = () => {

  const {
    houseName,
  } = useParams();

  const [data, setData] =
    useState([]);


  useEffect(() => {

    fetch(
      `https://stjosephweb.ilakshyaerp.in/api/school-house/${houseName}`
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setData(data)
      );

  }, [houseName]);


 return (

  <section className="w-full bg-[#F5F4DF] min-h-screen py-10">

    <div className="max-w-6xl mx-auto px-4">

      {
        data.length > 0
          ? (

            data.map((item) => (

              <div
                key={item.id}
                className="
                  mb-12
                  border-[3px]
                  border-[#F59E0B]
                  bg-white
                  shadow-xl
                "
              >

                {/* TITLE */}
                <div className="bg-[#FCD58A] border-b-[3px] border-[#F59E0B]">

                  <h2
                    className="
                      text-center
                      text-2xl
                      md:text-4xl
                      font-bold
                      text-[#072F5F]
                      py-4
                      uppercase
                    "
                  >

                    {item.title}

                  </h2>

                </div>

                {/* CONTENT */}
                <div className="p-4 bg-[#FFFDF6]">

                  {
                    item.type === "image"
                      ? (

                        <img
                          src={`https://stjosephweb.ilakshyaerp.in/uploads/school-house/${item.file}`}
                          alt=""
                          className="
                            w-full
                            border-2
                            border-[#E5E5E5]
                            rounded-md
                          "
                        />

                      )
                      : (

                        <iframe
                          src={`https://stjosephweb.ilakshyaerp.in/uploads/school-house/${item.file}`}
                          title=""
                          className="
                            w-full
                            h-[900px]
                            border-2
                            border-[#E5E5E5]
                            rounded-md
                          "
                        />

                      )
                  }

                </div>

              </div>

            ))

          )
          : (

            <div className="text-center py-24">

              <h2 className="text-4xl font-bold text-[#072F5F]">

                No House Data Found

              </h2>

            </div>

          )
      }

    </div>

  </section>
);
};

export default SingleHouse;